import moment from 'moment-timezone'

moment.locale('es')

const user_time_zone = moment.tz.guess(true)

moment.tz.setDefault(user_time_zone)

export default moment
